module.exports = __webpack_public_path__ + "static/media/002-tongue-depressor-wood.0f65993c.svg";